// Shopper theme choice: the `sf-theme` cookie overrides the store default.
// null means "follow the device" (prefers-color-scheme).

export const THEME_COOKIE = "sf-theme";
export const THEME_COOKIE_MAX_AGE = 60 * 60 * 24 * 365;

export type ThemeChoice = "light" | "dark";
export type StoreScheme = "light" | "dark" | "system";

export function parseThemeCookie(value: string | undefined | null): ThemeChoice | null {
  return value === "light" || value === "dark" ? value : null;
}

export function resolveThemeAttr(
  storeDefault: StoreScheme | undefined,
  cookie: string | undefined | null,
): ThemeChoice | null {
  const chosen = parseThemeCookie(cookie);
  if (chosen) return chosen;
  if (storeDefault === "dark") return "dark";
  if (storeDefault === "system") return null;
  return "light";
}
